"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatApproverRoleList = exports.pgApproverRoleLabel = exports.appRoleLabel = exports.APP_ROLE_LABELS = exports.APPROVER_ROLE_TO_APP_ROLE = exports.APP_ROLE_TO_APPROVER_ROLE = exports.isApproverRole = exports.approverRoleSchema = exports.APPROVER_ROLES = exports.INVOICING_V2_PASS_ON_ROLES = exports.INVOICING_V2_RESOLVE_VARIANCE_ROLES = exports.INVOICING_V2_ABSORB_ROLES = exports.INVOICING_V2_MASTER_ROLES = exports.FINANCING_PARTNER_ASSIGN_ROLES = exports.ELIGIBILITY_RULE_ROLES = exports.appRoleSchema = exports.APP_ROLES = void 0;
const zod_1 = require("zod");
// Adding a role: extend this list AND the `app_role` enum in backend/prisma/schema.prisma, then run `prisma migrate dev`.
exports.APP_ROLES = [
    'admin',
    'trader',
    'hedging',
    'cfo',
    'management',
    'operations',
    'investor',
    'risk_manager',
    'coo',
];
exports.appRoleSchema = zod_1.z.enum(exports.APP_ROLES);
// A partner's ruleset is the lender's contractual criteria, so authoring it, testing it and reading
// it all carry the same list. `admin` is listed for the reader's benefit; RolesGuard appends it anyway.
exports.ELIGIBILITY_RULE_ROLES = ['risk_manager', 'cfo', 'coo', 'admin'];
// Routing a deal to a financing partner is a credit decision, not an operations edit, so it is gated
// separately from the rest of the BL-level edit form. Kept distinct from ELIGIBILITY_RULE_ROLES
// because the two answer different questions and are free to diverge.
exports.FINANCING_PARTNER_ASSIGN_ROLES = [
    'risk_manager',
    'cfo',
    'coo',
    'admin',
];
// The entity, bank and VAT master anchors legal issuance, so only the CFO role maintains it (PR 32
// PRD FR-8, register item R10). Kept distinct from ELIGIBILITY_RULE_ROLES because the two answer
// different questions and are free to diverge; this one does not list `admin`.
exports.INVOICING_V2_MASTER_ROLES = ['cfo'];
// Absorbing a cost moves money into the overhead ledger Finance owns, so only the CFO role
// absorbs (register item R10, backend api-roles.ts binds absorb_cost to this list). The server
// admits admin on top of this list, so a UI gate that reads it must admit admin too.
exports.INVOICING_V2_ABSORB_ROLES = ['cfo'];
// Resolving a variance (received-paper or settlement-divergence) is an Operations or CFO write.
// The server admits admin on top of this list, so a UI gate that reads it must admit admin too.
exports.INVOICING_V2_RESOLVE_VARIANCE_ROLES = ['operations', 'cfo'];
// Card 2100: Operations owns the recharge of a cost it recorded, so pass-on is Operations work
// that Finance also does (register item R10, backend api-roles.ts binds pass_on_cost to this
// list). Absorb stays cfo-only above. The server admits admin on top of this list, so a UI gate
// that reads it must admit admin too.
exports.INVOICING_V2_PASS_ON_ROLES = ['operations', 'cfo'];
// Excludes `admin` (separate gate) and `trader` (not an approver in this org's policy).
exports.APPROVER_ROLES = [
    'hedging',
    'cfo',
    'management',
    'operations',
    'investor',
    'risk_manager',
    'coo',
];
exports.approverRoleSchema = zod_1.z.enum(exports.APPROVER_ROLES);
const isApproverRole = (role) => exports.APPROVER_ROLES.includes(role);
exports.isApproverRole = isApproverRole;
exports.APP_ROLE_TO_APPROVER_ROLE = {
    hedging: 'Hedging',
    cfo: 'CFO',
    management: 'Management',
    operations: 'Operations',
    risk_manager: 'Risk_Manager',
    coo: 'COO',
};
// Compile-time guard: if PG_APPROVER_ROLES gains a value, this satisfies clause
// errors until APPROVER_ROLE_TO_APP_ROLE covers it.
exports.APPROVER_ROLE_TO_APP_ROLE = {
    Hedging: 'hedging',
    CFO: 'cfo',
    Management: 'management',
    Operations: 'operations',
    Risk_Manager: 'risk_manager',
    COO: 'coo',
};
exports.APP_ROLE_LABELS = {
    admin: 'Admin',
    trader: 'Trader',
    hedging: 'Hedging',
    cfo: 'CFO',
    management: 'Management',
    operations: 'Operations',
    investor: 'Investor',
    risk_manager: 'Risk Manager',
    coo: 'COO',
};
const appRoleLabel = (role) => exports.APP_ROLE_LABELS[role];
exports.appRoleLabel = appRoleLabel;
// DB-style approver roles (Hedging, Risk_Manager, COO, …) reuse the same labels
// via the PG→app map, so a single source drives both role vocabularies.
const pgApproverRoleLabel = (role) => exports.APP_ROLE_LABELS[exports.APPROVER_ROLE_TO_APP_ROLE[role]];
exports.pgApproverRoleLabel = pgApproverRoleLabel;
const roleListFormatter = new Intl.ListFormat('en', { style: 'long', type: 'conjunction' });
const formatApproverRoleList = (roles) => roleListFormatter.format(roles.map(exports.pgApproverRoleLabel));
exports.formatApproverRoleList = formatApproverRoleList;
//# sourceMappingURL=roles.js.map